"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = require("@angular/common");
var forms_1 = require("@angular/forms");
var router_1 = require("@angular/router");
var http_1 = require("@angular/http");
var core_1 = require("@angular/core");
var shared_module_1 = require("@nw/ui-core-shared/shared.module");
var core_2 = require("@ngx-translate/core");
var http_2 = require("@angular/common/http");
var dealerblock_bid_service_1 = require("./shared/services/dealerblock-bid.service");
var dealerblock_best_offer_service_1 = require("./shared/services/dealerblock-best-offer.service");
var dealerblock_best_offer_history_service_1 = require("./shared/services/dealerblock-best-offer-history.service");
var dealerblock_view_best_offer_history_component_1 = require("./components/dealerblock-view-best-offer-history/dealerblock-view-best-offer-history.component");
var components_1 = require("./components");
var dealerblock_view_bid_history_component_1 = require("./components/dealerblock-view-bid-history/dealerblock-view-bid-history.component");
var dealerblock_accept_counter_offer_v1_component_1 = require("./components/components-v1/dealerblock-accept-counter-offer-v1/dealerblock-accept-counter-offer-v1.component");
var dealerblock_place_bid_v1_component_1 = require("./components/components-v1/dealerblock-place-bid-v1/dealerblock-place-bid-v1.component");
var dealerblock_buy_now_v1_component_1 = require("./components/components-v1/dealerblock-buy-now-v1/dealerblock-buy-now-v1.component");
var dealerblock_highest_bid_v1_component_1 = require("./components/components-v1/dealerblock-highest-bid-v1/dealerblock-highest-bid-v1.component");
var dealerblock_place_best_offer_component_1 = require("./components/dealerblock-place-best-offer/dealerblock-place-best-offer.component");
var dealerblock_decline_if_bid_back_bid_v1_component_1 = require("./components/components-v1/dealerblock-decline-if-bid-back-bid-v1/dealerblock-decline-if-bid-back-bid-v1.component");
var deadlerblock_bid_message_component_1 = require("./shared/deadlerblock-bid-message/deadlerblock-bid-message.component");
var NwDealerBlockModule = (function () {
    function NwDealerBlockModule() {
    }
    return NwDealerBlockModule;
}());
NwDealerBlockModule.decorators = [
    { type: core_1.NgModule, args: [{
                imports: [
                    shared_module_1.NwSharedModule,
                    common_1.CommonModule,
                    forms_1.FormsModule,
                    router_1.RouterModule,
                    http_2.HttpClientModule,
                    http_1.HttpModule,
                    core_2.TranslateModule
                ],
                declarations: [
                    components_1.DealerblockPlaceBidComponent,
                    components_1.DealerblockHighestBidComponent,
                    components_1.DealerblockBidHistoryModalComponent,
                    components_1.DealerblockBuyNowComponent,
                    components_1.DealerblockBestOfferPriceComponent,
                    components_1.DealerblockBestOfferCounteredComments,
                    components_1.DealerblockAcceptCounterOfferComponent,
                    components_1.DealerblockDeclineCounterOfferComponent,
                    components_1.BestOfferCounteredDeclinedByComponent,
                    dealerblock_view_bid_history_component_1.DealerblockViewBidHistoryComponent,
                    dealerblock_view_best_offer_history_component_1.DealerblockViewBestOfferHistoryComponent,
                    components_1.DealerblockBestOfferHistoryModalComponent,
                    dealerblock_place_best_offer_component_1.DealerblockPlaceBestOfferComponent,
                    components_1.DealerblockDeclineCounterOfferV1Component,
                    dealerblock_accept_counter_offer_v1_component_1.DealerblockAcceptCounterOfferV1Component,
                    dealerblock_place_bid_v1_component_1.DealerblockPlaceBidV1Component,
                    dealerblock_buy_now_v1_component_1.DealerblockBuyNowV1Component,
                    dealerblock_highest_bid_v1_component_1.DealerblockHighestBidV1Component,
                    components_1.DealerblockBestOfferCounteredCommentsV1Component,
                    dealerblock_decline_if_bid_back_bid_v1_component_1.DealerblockDeclineIfBidBackBidV1Component,
                    deadlerblock_bid_message_component_1.DeadlerblockBidMessageComponent
                ],
                exports: [
                    components_1.DealerblockPlaceBidComponent,
                    components_1.DealerblockHighestBidComponent,
                    components_1.DealerblockBidHistoryModalComponent,
                    components_1.DealerblockBuyNowComponent,
                    components_1.DealerblockBestOfferPriceComponent,
                    components_1.DealerblockBestOfferCounteredComments,
                    components_1.DealerblockAcceptCounterOfferComponent,
                    components_1.DealerblockDeclineCounterOfferComponent,
                    components_1.BestOfferCounteredDeclinedByComponent,
                    dealerblock_view_bid_history_component_1.DealerblockViewBidHistoryComponent,
                    dealerblock_view_best_offer_history_component_1.DealerblockViewBestOfferHistoryComponent,
                    components_1.DealerblockBestOfferHistoryModalComponent,
                    dealerblock_place_best_offer_component_1.DealerblockPlaceBestOfferComponent,
                    components_1.DealerblockDeclineCounterOfferV1Component,
                    dealerblock_accept_counter_offer_v1_component_1.DealerblockAcceptCounterOfferV1Component,
                    dealerblock_place_bid_v1_component_1.DealerblockPlaceBidV1Component,
                    dealerblock_buy_now_v1_component_1.DealerblockBuyNowV1Component,
                    dealerblock_highest_bid_v1_component_1.DealerblockHighestBidV1Component,
                    components_1.DealerblockBestOfferCounteredCommentsV1Component,
                    dealerblock_decline_if_bid_back_bid_v1_component_1.DealerblockDeclineIfBidBackBidV1Component,
                    deadlerblock_bid_message_component_1.DeadlerblockBidMessageComponent
                ],
                providers: [
                    dealerblock_bid_service_1.DealerBlockBidService,
                    dealerblock_best_offer_service_1.DealerblockBestOfferService,
                    dealerblock_best_offer_history_service_1.DealerblockBestOfferHistoryService
                ],
                schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
            },] },
];
/** @nocollapse */
NwDealerBlockModule.ctorParameters = function () { return []; };
exports.NwDealerBlockModule = NwDealerBlockModule;
//# sourceMappingURL=dealerblock.module.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nw/dealerblock-bid-ui/dealerblock.module.js
// module id = Xz+f
// module chunks = 0